
<template>
    <InView
        :threshold="0.0"
        class="cta-cards"
        :class="[
            sticky ? 'cta-cards--sticky' : '',
            inline ? 'cta-cards--inline' : ''
        ]"
    >
        <CraftLink
            v-for="(card, index) in ctaCards.cards"
            :key="card.id"
            v-slot="{ to, label }"
            :link="card.cta"
        >
            <CtaCard
                :to
                :title="card.title"
                :description="card.description"
                :cta-label="label"
                :image="card?.image?.[0]"
                :background-color="colors[index % colors.length]"
                class="cta-cards__card"
                :inline
                :medium
            />
        </CraftLink>
    </InView>
</template>

<script setup>
defineProps({
    sticky: {
        type: Boolean,
        default: false,
    },
    inline: {
        type: Boolean,
        default: false,
    },
    medium: {
        type: Boolean,
        default: false
    }
});

const generalStore = useGeneralStore();

const { ctaCards } = storeToRefs(generalStore);

const colors = ref([
    'var(--color-west-salmon)',
    'var(--color-oost-lila)',
    'var(--color-nieuw-west-green)',
]);
</script>

<style lang="less" src="./CtaCards.less" />
